import React from 'react'
import NextImage from 'next/image'
import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import useConfig from '../../../config/state/use-config'
import { UiIcon } from '../../../ui/atoms/Icon'
import Modal from '../../../modal/components/modal/modal'
import DedicationPreConversionPreview from '../../../order/components/dedication/dedication-pre-conversion-preview'

interface StepLayoutRootProps {
  children: React.ReactNode
}

export default function StepLayoutRoot({ children }: StepLayoutRootProps) {
  const { t } = useTranslation()
  const config = useConfig()

  return (
    <Root>
      <HeaderSection>
        <DedicationPreConversionPreview />
        <Header>
          <BackLink
            href={config.header.logoLink}
            title={t('stepLayoutRoot.backToCampaignPage', 'Back to campaign page')}
          >
            <UiIcon name="chevron_left" w={20} h={20} />
            <BackText>{t('stepLayoutRoot.back', 'Back')}</BackText>
          </BackLink>
          <LogoContainer>
            <LogoLink href={config.header.logoLink} title={config.header.logoAltText}>
              <Logo
                width={600}
                height={600}
                alt={config.header.logoAltText}
                src={config.header.logoAssetUrl}
              />
            </LogoLink>
          </LogoContainer>
          <div></div>
        </Header>
      </HeaderSection>

      <Main>{children}</Main>
      <Modal />
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.header`
  top: 0;
  z-index: 1;
  display: flex;
  height: 64px;
  padding: 0 16px;
  position: sticky;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #eaeaea;
  justify-content: space-between;
`

const LogoContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
`

const LogoLink = styled.a`
  display: flex;
  align-items: center;
`

const BackLink = styled.a`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  font-size: 14px;
`

const BackText = styled.span`
  margin-left: 4px;

  @media (max-width: 768px) {
    display: none;
  }
`

const Logo = styled(NextImage)`
  max-height: 48px;
  width: auto;
`

const Main = styled.main`
  padding: 0 16px;
`
